// create space form input validation

function isValidUrl(url) {
    try {
        const parsed = new URL(url);
        return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch (_) {
        return false;
    }
}

export const createSpacesValidationForm = (data) => {
    const err = {};
    const requiresArea = ["9", "10", "11"];
    console.log(data.businessType,"datahh validaion ka")
    
    if (data.storageCategoryId === '') {
        err.storageCategoryId = 'Storage type is required';
    }

    if (data.storageTypeId === '') {
        err.storageTypeId = 'Listing type is required';
    }

    if (data.quantity === '') {
        err.quantity = 'quantity type is required';
    }
    
    if (Number(data.businessType) !== 9 && data.spaceLength === '') {
        err.spaceLength = 'Space length is required';
    } else if (data.spaceLength && Number(data.spaceLength) <= 0) {
        err.spaceLength = 'Space length cannot be negative or zero';
    } else if (data.spaceLength && Number(data.spaceLength) > 500) {
        err.spaceLength = 'Space length cannot be greater than 500';
    }

    if (Number(data.businessType) !== 9 && data.spaceWidth === '') {
        err.spaceWidth = 'Space width is required';
    } else if (data.spaceWidth && Number(data.spaceWidth) <= 0) {
        err.spaceWidth = 'Space width cannot be negative or zero';
    } else if (data.spaceWidth && Number(data.spaceWidth) > 500) {
        err.spaceWidth = 'Space width cannot be greater than 200';
    }

    if (Number(data.businessType) !== 9 && data.spaceHeight === '') {
        err.spaceHeight = 'Space height is required';
    } else if (data.spaceHeight && Number(data.spaceHeight) <= 0) {
        err.spaceHeight = 'Space height cannot be negative or zero';
    } else if (data.spaceHeight && Number(data.spaceHeight) > 100) {
        err.spaceHeight = 'Space height cannot be greater than 100';
    }

    console.log(requiresArea.includes(data.businessType),"2222")
    /* if (requiresArea.includes(data.businessType)) {
        if (data.area === '' || data.area === undefined) {
            err.area = 'Total area is required for Warehouse, Commercial Lot, or Food Truck Parking';
        } else if (isNaN(data.area) || Number(data.area) <= 0) {
            err.area = 'Total area must be a numeric value greater than zero';
        } else if (Number(data.area) > 1000000) {
            err.area = 'Total area cannot exceed 1,000,000';
        }
    
        if (data.availableArea === '' || data.availableArea === undefined) {
            err.availableArea = 'Available area is required for Warehouse, Commercial Lot, or Food Truck Parking';
        } else if (isNaN(data.availableArea) || Number(data.availableArea) <= 0) {
            err.availableArea = 'Available area must be a numeric value greater than zero';
        } else if (Number(data.availableArea) > 1000000) {
            err.availableArea = 'Available area cannot exceed 1,000,000';
        }
    
        if (data.minimumLeaseableArea && (isNaN(data.minimumLeaseableArea) || Number(data.minimumLeaseableArea) <= 0)) {
            err.minimumLeaseableArea = 'Minimum leaseable area must be a numeric value greater than zero';
        } else if (data.minimumLeaseableArea && Number(data.minimumLeaseableArea) > 1000000) {
            err.minimumLeaseableArea = 'Minimum leaseable area cannot exceed 1,000,000';
        }
    
        if (data.pricePerSqFt === '' || data.pricePerSqFt === undefined) {
            err.pricePerSqFt = '$/sq ft is required for Warehouse, Commercial Lot, or Food Truck Parking';
        } else if (isNaN(data.pricePerSqFt) || Number(data.pricePerSqFt) <= 0) {
            err.pricePerSqFt = '$/sq ft must be a numeric value greater than zero';
        } else if (Number(data.pricePerSqFt) > 1000000) {
            err.pricePerSqFt = '$/sq ft cannot exceed 1,000,000';
        }
    } */    
    
    if (data.title === '') {
        err.title = 'Listing title is required';
    } else if (data?.title?.length > 100) {
        err.title = 'Listing title must be less than or equal to 100 characters';
    }
    if (data.description === '') {
        err.description = 'Listing description is required';
    }
    
    if (data?.accessDetails && data?.accessDetails?.length > 500) {
        err.accessDetails = 'Access details must be less than or equal to 500 characters';
    }

    // else if (data?.description?.length > 1000) {
    //     err.description = 'Listing description must be less than or equal to 1000 characters';
    // }
    if (!data.spaceAmenities.some((element) => element.isChecked)) {
        err.spaceAmenities = 'Please atleast select one amenity';
    }
    if (data.propertyType === '') {
        err.propertyType = 'Property type is required';
    }
    if (data.propertyType === '2' && data.businessType ==='') {
        err.businessType = 'Business type is required';
    }
    if (data.nearbyLandmark === '2' && data.nearbyLandmark ==='') {
        err.nearbyLandmark = 'Nearby Landmark is required';
    }
    // if (data.accessFrequency === '' || !data.accessFrequency) {
    //   err.accessFrequency = 'Access frequency is required';
    // }

    if (!data?.monthlyRate && !data?.dailyRate && !data.weeklyRate) {
        err.rate = 'Rate is required';
    } else {
        err.rate = '';
    }

    if (Number(data.monthlyRate)) {
        if (Number(data.monthlyRate) <= 0) {
            err.rate = 'Monthly rate must be greater than or equal to 1';
        }
    }

    if (Number(data.dailyRate)) {
        if (Number(data.dailyRate) <= 0) {
            err.rate = 'dailyRate rate must be greater than or equal to 1';
        }
    }

    if (Number(data.weeklyRate)) {
        if (Number(data.weeklyRate) <= 0) {
            err.rate = 'Weekly rate must be greater than or equal to 1';
        }
    }

    // Backup comment start
    // if (data.weeklyRate === '' && data.monthlyRate === '') {
    //     err.rate = 'Weekly or monthly rate is required';
    // } else if (data.monthlyRate === '' && !Number(data?.weeklyRate)) {
    //     err.rate = 'Weekly rate must be greater than or equal to 1';
    // } else if (data.weeklyRate === '' && !Number(data?.monthlyRate)) {
    //     err.rate = 'Monthly rate must be greater than or equal to 1';
    // } else if (!Number(data?.weeklyRate) && !Number(data?.monthlyRate)) {
    //     err.rate = 'Weekly or monthly rate must be greater than or equal to 1';
    // }
    // Backup comment end
    // if (data.monthlyRate === '' || data.weeklyRate === '' || (data.monthlyRate === '' && data.weeklyRate === '')) {
    //     err.rate = 'Monthly and weekly rate is required';
    // } else if (
    //     Number(data.monthlyRate) < 0 ||
    //     Number(data.weeklyRate) < 0 ||
    //     (Number(data.monthlyRate) < 0 && Number(data.weeklyRate) < 0)
    // ) {
    //     err.rate = 'Monthly and weekly rate cannot be negative';
    // } else if (
    //     !Number(data.monthlyRate) ||
    //     !Number(data.weeklyRate) ||
    //     (!Number(data.monthlyRate) && !Number(data.weeklyRate))
    // ) {
    //     err.rate = 'Monthly and weekly rate must be greater than or equal to 1';
    // }

    if (data.approvalOnVisit === null) {
        err.approvalOnVisit = 'Approval on visit is required';
    }

    if (data.isAffiliateSpace) {
        if (!data.affiliateUrl || !isValidUrl(data.affiliateUrl)) {
            err.affiliateUrl = 'A valid approval URL is required';
        }
    }
    
    /* if (data.businessType === '9') {
        if (data.floorLoadCapacity && (!data.floorLoadCapacity || isNaN(data.floorLoadCapacity) || Number(data.floorLoadCapacity) <= 0)) {
            err.floorLoadCapacity = 'Floor Load Capacity must be a positive number';
        }
        
        // if (!data.accessPoints || data.accessPoints.trim() === '') {
        //     err.accessPoints = 'Access Points description is required';
        // }
        
        if (data.loadingDocks && (!data.loadingDocks || isNaN(data.loadingDocks) || Number(data.loadingDocks) < 0)) {
            err.loadingDocks = 'Number of Loading Docks must be a non-negative number';
        }
        
        if (data.clearanceHeight && (!data.clearanceHeight || isNaN(data.clearanceHeight) || Number(data.clearanceHeight) <= 0)) {
            err.clearanceHeight = 'Clearance Height must be a positive number';
        }
        
        // if (!data.permissibleUses || data.permissibleUses.trim() === '') {
        //     err.permissibleUses = 'Permissible Uses description is required';
        // }
        
        if (data.leaseOptions && (
            !['Short-Term (1-6 months)', 'Medium-Term (6-12 months)', 'Long-Term (1+ years)', 'Flexible'].includes(
                data.leaseOptions
            )
        )) {
            err.leaseOptions = 'Invalid Lease Option selected';
        }
    } */
 
    return err;
};
